import { render } from "./results.vue?vue&type=template&id=34fb9378&scoped=true"
import script from "./results.vue?vue&type=script&lang=js"
export * from "./results.vue?vue&type=script&lang=js"

import "./results.vue?vue&type=style&index=0&id=34fb9378&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fb9378"]])

export default __exports__